import { api } from "@/services/api";

export interface MFASendEmailBody {
  email: string;
  language: "pt" | "en";
  full_name: string;
}

export const mfaApi = {
  async sendEmail(body: MFASendEmailBody) {
    await api.post("/mfa/send-email", body);
  },
};
